<template>
	<div class="my-table logManagementPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t('systemeManagement.txt1')}}</span>
				<span>{{$t('systemeManagement.txt2')}} / {{$t('systemeManagement.txt2')}}</span>
			</div>
		</div>
			<!-- 面包屑 -->
			<el-card class="tableCard p30 mt0">
				<div class=" flexCenterBtn">
					<Tag></Tag>
					<div class="flexEndBtn">
						<div class="searchBtn ml20" @click="handleSave">{{$t('systemeManagement.txt3')}}</div>
					</div>
				</div>
				<div class="dataBox">
					<p class="subTitle">{{$t('systemeManagement.txt4')}}</p>
					<p>
						<el-switch
							@change="onChangeSwitch"
						  v-model="detail.allowDownload"
						  active-text=""
						  :inactive-text="$t('systemeManagement.txt5')">
						</el-switch>
					</p>
					<p class="subTitle">{{detail.allowDownload?$t('systemeManagement.txt6'):$t('systemeManagement.txt7')}}</p>
					<div class="transferBox">
						<el-transfer filterable :filter-placeholder="$t('systemeManagement.txt8')" :filter-method="filterMethod" :titles="[$t('systemeManagement.txt9'), $t('systemeManagement.txt9')]" v-model="checkedList" :props="transferProps" :data="dataList">
						</el-transfer>
					</div>
				</div>
				
			</el-card>
				
	</div>
</template>

<script>
	import qs from 'qs';
	import Tag from './components/tag.vue';
	import menuMixin from './menuMixin';
	export default {
		mixins: [menuMixin],
		components: {
			Tag
		},
		data() {
			return {
				checkedList: [],
				transferProps: {
					key: 'id',
					label: 'userName'
				},
				//用于获取数据列表
				queryInfo: {
        		  pageNum: 0,
        		  size: 999,
        		  search: ''
        		},
				dataList: [],
				detail:{}
			};
		},
		created() {
			this.getDetail();
		},
		methods: {
			// 系统设置详细
			async getDetail(){
				const { data: res } = await this.$http.post("/systemSetting/detail");
				if(!res.success){
					return this.$message.error(res.message);
				}
				this.dataList = [];
				this.checkedList = [];
				this.detail = res.result;
				if(this.detail.allowDownload && this.detail.allowDownloadOfNotAllowUsers.length>0){
					this.detail.allowDownloadOfNotAllowUsers.map(e=>{
						this.checkedList.push(e.userId);
					})
				}
				if(!this.detail.allowDownload && this.detail.notAllowDownloadOfAllowUser.length>0){
					this.detail.notAllowDownloadOfAllowUser.map(e=>{
						this.checkedList.push(e.userId);
					})
				}
				if(this.detail.users && this.detail.users.length>0){
					this.detail.users.map(e=>{
						let item = {
							id:e.id,
							userName:e.userName
						}
						this.dataList.push(item);
					})
				}
			},
			// 开关触发
			onChangeSwitch(){
				if(this.detail.allowDownload && this.detail.allowDownloadOfNotAllowUsers.length>0){
					this.checkedList = [];
					this.detail.allowDownloadOfNotAllowUsers.map(e=>{
						this.checkedList.push(e.userId);
					})
				}
				if(!this.detail.allowDownload && this.detail.notAllowDownloadOfAllowUser.length>0){
					this.checkedList = [];
					this.detail.notAllowDownloadOfAllowUser.map(e=>{
						this.checkedList.push(e.userId);
					})
				}

			},
			// 系统设置-保存
			async handleSave(){
				const userIds = this.checkedList.map(item => {
					return item
				})
				let data = {
					allowDownload:this.detail.allowDownload,
					userIds
				}
				const { data: res } = await this.$http.post("/systemSetting/allowDownloadSave",data);
				if(!res.success){
					return this.$message.error(res.message);
				}
                this.$message.success(this.$t('systemeManagement.txt10'));
				this.getDetail();
			},
			filterMethod(query, item) {
				return item.userName.indexOf(query) > -1;
			},
			// 返回上一页
			returnPage() {
				this.$router.go(-1);
			}
		},
	};
</script>

<style lang="less" scoped>
	.logManagementPage {
		/deep/ .el-input{
			width: 92%;
		}
		/deep/ .el-switch__label{
			color: #000;
		}
		/deep/ .el-switch__label.is-active{
			color:#000;
		}
		/deep/ .el-switch.is-checked .el-switch__core{
			border-color: #1B3B7C;
    		background-color: #1B3B7C;
		}
		.transferBox{
			.elTransferTitle{
				padding:3.1rem 0 2.1rem 0;
				font-size: 14px;
				font-weight: 500;
				color: #222222;
			}
			/deep/ .el-transfer{
				display: flex;
				justify-content: center;
				.el-transfer-panel{
					background: #F4F4F4;
					border-radius: 18px;
					overflow: hidden;
					border: none;
				}
				.el-transfer-panel__header{
					background: #DFE2E8;
					.el-checkbox__label{
						font-weight: 500;
						color: #1B3B7C;
						font-size: 14px;
					}
				}
				.el-transfer__buttons{
					display: flex;
					justify-content: center;
					align-content: center;
					padding: 0 !important;
					.el-transfer__button{
						padding: 0 !important;
						width: auto;
						height: auto;
						background: #fff;
						border: none;
						margin: 0;
					}
					.el-button+.el-button{
						margin: 0;
					}
				}
			}
		}
		.back {
			display: inline-block;
			margin-right: 2.6rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}
		.mt-50{
			margin-top: -60px;
		}
		.mb15 {
			margin-bottom: 1.5rem;
		}

		.searchBox {
			/*width: 33.6rem !important;*/
			height: 3.2rem;

			.btnC {
				padding: 0.6rem 2.6rem;
			}
		}

		.tips {
			font-size: 1.4rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #98B9FF;
			margin-top: -10px;
		}

		.dataBox{
			margin:30px 20px;
			.subTitle{
				font-size: 14px;
				font-weight: 500;
				color: #222222;
			}
		}
		}
		.handleBtn{
			padding: 0;
		}
	</style>
